import { LucideIcon, TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface KPICardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  gradient: string;
  change?: number;
  subtitle?: string;
}

export function KPICard({ title, value, icon: Icon, gradient, change, subtitle }: KPICardProps) {
  const TrendIcon = change && change > 0 ? TrendingUp : change && change < 0 ? TrendingDown : Minus;
  const trendColor =
    change && change > 0
      ? 'text-emerald-500'
      : change && change < 0
        ? 'text-red-500'
        : 'text-gray-400';

  return (
    <div className="group relative bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700/50 p-5 hover:shadow-lg hover:shadow-[#16c47f]/5 transition-all duration-300 cursor-default overflow-hidden">
      {/* Subtle gradient overlay on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#16c47f]/0 to-[#16c47f]/0 group-hover:from-[#16c47f]/[0.02] group-hover:to-transparent transition-all duration-500 rounded-2xl" />

      <div className="relative">
        <div className="flex items-start justify-between mb-4">
          <div
            className={`w-11 h-11 bg-gradient-to-br ${gradient} rounded-xl flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform duration-300`}
          >
            <Icon className="w-5 h-5 text-white" />
          </div>
          {change !== undefined && (
            <div
              className={`flex items-center gap-1 text-xs font-medium ${trendColor} bg-gray-50 dark:bg-gray-700/50 rounded-lg px-2 py-1`}
            >
              <TrendIcon className="w-3 h-3" />
              <span>
                {change > 0 ? '+' : ''}
                {change}%
              </span>
            </div>
          )}
        </div>
        <h3 className="text-gray-400 dark:text-gray-500 text-[11px] font-semibold uppercase tracking-wider mb-1">
          {title}
        </h3>
        <p className="text-2xl font-bold text-gray-900 dark:text-white group-hover:text-[#16c47f] transition-colors duration-200">
          {value}
        </p>
        {subtitle && <p className="text-gray-400 dark:text-gray-500 text-xs mt-1.5">{subtitle}</p>}
      </div>
    </div>
  );
}
